import React from "react";
import { Event } from "@uno/protocol";
import { AppContext } from "context";
import { useSounds } from "context/SoundContext";
import useStoreRoomPlayer from "store/useStoreRoomPlayer";

const Sound = () => {
    const { socket } = React.useContext(AppContext);
    const { play } = useSounds();

    React.useEffect(() => {
        socket?.on(Event.PlayPutCardSound, (payload?: { playerId?: string }) => {
            if(payload?.playerId && payload.playerId === useStoreRoomPlayer.getState().roomPlayer?.player.id) {
                return;
            }

            play("putCard");
        });

        return () => {
            socket?.off(Event.PlayPutCardSound);
        };
    }, [socket, play]);

    return null;
}

export default Sound;
